module.exports = {

    setUpCurrentPageChangeListener: function() {

        this.listenTo( this.model, 'change:isCurrentPage', this.toggleIsCurrentPage );
    },

    toggleIsCurrentPage: function() {

        var isCurrentPage = this.isCurrentPage();

        // Could combo but this was causing issue inheriting mixins in CSS
        this.ui.pageLink.toggleClass( 'fr-page-link-current-page', isCurrentPage );

        this.$el.toggleClass( 'fr-hit-row-view-page-current', isCurrentPage );

    },

    ui: {
        pageLink: '.fr-page-link'
    },

    events: {
        'click @ui.pageLink': 'pageLinkClick'
    },

    // TODO: want a 'setPageNavigability' fn like the note views and probably want to use the same component
    pageLinkClick: function(e) {

        e.preventDefault();
        this.channel.request('vChannel').command( 'goToPageId', this.getPageId() );

    }


};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/pageRow/rowWithPageLinkMixin.js
 ** module id = 631
 ** module chunks = 0
 **/